import { makeEnumWithDataAndLabels } from '../Base.js'
import { DataTable } from './DataTable.js'
import { makeEnum } from '../Base.js'
import { Units } from '../Common/Units.js'

/*
Recessed fluorescent luminaire without lens
Recessed fluorescent luminaire with lens
Downlight compact fluorescent luminaire
Downlight incandescent luminaire
Non-in-ceiling fluorescent luminaire
Recessed LED troffer partial aperture diffuser
Recessed LED troffer uniform diffuser
Recessed high-efficacy LED troffer
Recessed LED downlight
Recessed LED retrofit kit 2×4
Recessed LED color tuning fixture
High-bay LED fixture
Linear pendant LED fixture
Unknown
*/
// NOTE - keep this for backwards compatibility
export let LuminaireType = makeEnum({
  RecessedFluorescentLuminaireWithoutLens: 'Recessed fluorescent luminaire without lens',
  RecessedFluorescentLuminaireWithLens: 'Recessed fluorescent luminaire with lens',
  DownlightCompactFluorescentLuminaire: 'Downlight compact fluorescent luminaire',
  DownlightIncandescentLuminaire: 'Downlight incandescent luminaire',
  NonInCeilingFluorescentLuminaire: 'Non-in-ceiling fluorescent luminaire',
  RecessedLEDTrofferPartialApertureDiffuser: 'Recessed LED troffer partial aperture diffuser',
  RecessedLEDTrofferUniformDiffuser: 'Recessed LED troffer uniform diffuser',
  RecessedHighEfficacyLEDTroffer: 'Recessed high-efficacy LED troffer',
  RecessedLEDDownlight: 'Recessed LED downlight',
  RecessedLEDRetrofitKit2x4: 'Recessed LED retrofit kit 2×4',
  RecessedLEDColorTuningFixture: 'Recessed LED color tuning fixture',
  HighBayLEDFixture: 'High-bay LED fixture',
  LinearPendantLEDFixture: 'Linear pendant LED fixture',
  Unknown: 'Unknown',
})

let LuminaireData = {
  "Recessed fluorescent luminaire without lens": {
    "type": "Recessed fluorescent luminaire without lens",
    "F_space": 0.69*100,
    "F_rad": 0.58*100,
  },
  "Recessed fluorescent luminaire with lens": {
    "type": "Recessed fluorescent luminaire with lens",
    "F_space": 0.45*100,
    "F_rad": 0.67*100,
  },
  "Downlight compact fluorescent luminaire": {
    "type": "Downlight compact fluorescent luminaire",
    "F_space": 0.18*100,
    "F_rad": 0.975*100,
  },
  "Downlight incandescent luminaire": {
    "type": "Downlight incandescent luminaire",
    "F_space": 0.75*100,
    "F_rad": 0.975*100,
  },
  "Non-in-ceiling fluorescent luminaire": {
    "type": "Non-in-ceiling fluorescent luminaire",
    "F_space": 1.0*100,
    "F_rad": 0.535*100
  },
  "Recessed LED troffer partial aperture diffuser": {
    "type": "Recessed LED troffer partial aperture diffuser",
    "F_space": 0.565*100,
    "F_rad": 0.42*100
  },
  "Recessed LED troffer uniform diffuser": {
    "type": "Recessed LED troffer uniform diffuser",
    "F_space": 0.55*100,
    "F_rad": 0.365*100
  },
  "Recessed high-efficacy LED troffer": {
    "type": "Recessed high-efficacy LED troffer",
    "F_space": 0.59*100,
    "F_rad": 0.51*100
  },
  "Recessed LED downlight": {
    "type": "Recessed LED downlight",
    "F_space": 0.48*100,
    "F_rad": 0.165*100
  },
  "Recessed LED retrofit kit 2×4": {
    "type": "Recessed LED retrofit kit 2×4",
    "F_space": 0.47*100,
    "F_rad": 0.365*100
  },
  "Recessed LED color tuning fixture": {
    "type": "Recessed LED color tuning fixture",
    "F_space": 0.545*100,
    "F_rad": 0.41*100
  },
  "High-bay LED fixture": {
    "type": "High-bay LED fixture",
    "F_space": 1.0*100,
    "F_rad": 0.465*100
  },
  "Linear pendant LED fixture": {
    "type": "Linear pendant LED fixture",
    "F_space": 1.0*100,
    "F_rad": 0.575*100
  },
  "Unknown": {
    "type": "Unknown",
    "F_space": 0.64*100,
    "F_rad": 0.54*100
  }
}

export function GetLuminaireDataTable() {
  // Preprocess the table to round all values to nearest integer
  for (const key in LuminaireData) {
    let entry = LuminaireData[key]
    entry.F_space = Math.round(entry.F_space)
    entry.F_rad = Math.round(entry.F_rad)
  }
  return DataTable.create([
    {
      name: 'Luminaire Type',
      field: 'type',
      units: Units.None,
    },
    {
      name: 'Radiant Fraction',
      field: 'F_rad',
      units: Units.Percent,
    },
    {
      name: 'Space Fraction',
      field: 'F_space',
      units: Units.Percent,
    }
  ], LuminaireData);
}